<template>
  <Row>
    <Col :xs="12" :l="10" :lOffset="1">
      <template v-for="(item, idx1) in toggles">
        <InViewAnimation :delay="idx1 * 4 + 1" :key="`seriveToggles-${idx1}`">
          <Headline :slot="0" :staticClass="idx1 > 0 ? `${el}__stSubline` : ''" size="xs">
            {{ item.headline }}
          </Headline>

          <div
            :slot="idx2 + 1"
            v-for="(row, idx2) in item.rows"
            :key="`seriveToggles-${idx2}`"
            :class="{
              [`${el}__stRow`]: true,
              [`${el}__stRow--active`]: active(row.id),
            }"
          >
            <div>
              <Copy element="div" color="tertiaryLight">{{ row.service }}</Copy>
              <Copy element="div" size="l" bold>{{ row.description }}</Copy>
              <Link
                class="u-margin__top--2"
                :onClick="() => openContentSheet(row.id)"
                icon="arrow-right-line"
                iconPos="right"
              >
                {{ $t('cs.wizard.switcherToggle.link') }}
              </Link>
            </div>
            <ToggleSwitch
              :class="`${el}__stToggleSwitch`"
              inactiveLabel="Nein"
              activeLabel="Ja"
              :checked="active(row.id)"
              :labelOnSamePosition="$matchMedia.m"
              :disabled="
                (row.id === 'pflegegeld' || row.id === 'pflegesachleistungen') &&
                checked('kombinationsleistung')
              "
              @click="handleChange(row.id)"
            />
          </div>
        </InViewAnimation>
      </template>
    </Col>
  </Row>
</template>

<script>
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import ToggleSwitch from '@/objects/ToggleSwitch';
import Link from '@/objects/Link';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import InViewAnimation from '@/components/InViewAnimation';

import { mapFieldsCareService, mapFieldsHealth } from '@/store/mapFields';

import { CARESERVICE_UPDATE_FACT } from '@/store/actions/careService';
import { CONTENT_SHEET_CONTENT } from '@/store/actions/contentSheet';

export default {
  name: 'SeriveToggles',
  props: {
    id: String,
    content: Object,
    el: String,
  },
  components: {
    Copy,
    Headline,
    ToggleSwitch,
    Link,
    Row,
    Col,
    InViewAnimation,
  },
  computed: {
    ...mapFieldsCareService(['careServiceFacts', 'careServiceStepIsValid']),
    ...mapFieldsHealth(['healthDataLoaded', 'careLevel']),
  },
  data() {
    return {
      toggles: [],
    };
  },
  mounted() {
    this.careServiceStepIsValid = true;

    const { toggles, togglesPg1 } = this.content;
    this.toggles = this.careLevel === 1 ? togglesPg1 : toggles;
  },
  methods: {
    active(id) {
      return (id === 'pflegegeld' || id === 'pflegesachleistungen') &&
        this.checked('kombinationsleistung')
        ? false
        : this.checked(id);
    },

    handleChange(id) {
      this.$store.dispatch(CARESERVICE_UPDATE_FACT, {
        id,
        value: this.careServiceFacts[id] === 2 ? null : 2,
      });

      /**
       * Da es Pflegesachleistungen und Pflegegeld nicht parallel gibt,
       * wird jeweils die andere Leistung deaktiviert
       */

      if (id === 'pflegesachleistungen' && this.checked('pflegegeld')) {
        this.$store.dispatch(CARESERVICE_UPDATE_FACT, {
          id: 'pflegegeld',
          value: null,
        });
      }

      if (id === 'pflegegeld' && this.checked('pflegesachleistungen')) {
        this.$store.dispatch(CARESERVICE_UPDATE_FACT, {
          id: 'pflegesachleistungen',
          value: null,
        });
      }

      if (id === 'kombinationsleistung') {
        this.$store.dispatch(CARESERVICE_UPDATE_FACT, {
          id: 'pflegegeld',
          value: null,
        });
        this.$store.dispatch(CARESERVICE_UPDATE_FACT, {
          id: 'pflegesachleistungen',
          value: null,
        });
      }
    },

    checked(id) {
      return this.careServiceFacts[id] === 2 || this.careServiceFacts[id] === 3;
    },

    openContentSheet(sheetId) {
      this.$store.dispatch(CONTENT_SHEET_CONTENT, { sheetId: `pflegeleistungen/${sheetId}` });
    },
  },
};
</script>
